import { updateCSS as p, removeCSS as g } from "./Dom/dynamicCSS.mjs";
var n;
function b(e) {
  var o = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), t = document.createElement("div");
  t.id = o;
  var r = t.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var a, i;
  if (e) {
    var d = getComputedStyle(e);
    r.scrollbarColor = d.scrollbarColor, r.scrollbarWidth = d.scrollbarWidth;
    var c = getComputedStyle(e, "::-webkit-scrollbar"), l = parseInt(c.width, 10), h = parseInt(c.height, 10);
    try {
      var s = l ? "width: ".concat(c.width, ";") : "", u = h ? "height: ".concat(c.height, ";") : "";
      p(`
#`.concat(o, `::-webkit-scrollbar {
`).concat(s, `
`).concat(u, `
}`), o);
    } catch (m) {
      console.error(m), a = l, i = h;
    }
  }
  document.body.appendChild(t);
  var f = e && a && !isNaN(a) ? a : t.offsetWidth - t.clientWidth, v = e && i && !isNaN(i) ? i : t.offsetHeight - t.clientHeight;
  return document.body.removeChild(t), g(o), {
    width: f,
    height: v
  };
}
function W(e) {
  return typeof document > "u" ? 0 : ((e || n === void 0) && (n = b()), n.width);
}
export {
  W as default
};
//# sourceMappingURL=getScrollBarSize.mjs.map
